const phoneFormat = (val: string) =>
  val
    ? `${val ? '(' : ''}${val?.slice(0, 3)}${val?.length > 3 ? ') ' : ''}${val?.slice(3, 6)}${
        val?.length > 7 ? ' ' : ''
      }${val?.slice(6, 10)}`
    : '';

export default phoneFormat;
